import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import Cookies from 'universal-cookie';

import common_en from "./lang/en/common.json";
import common_ar from "./lang/ar/common.json";

var default_lng = "en";

const cookies = new Cookies();
if(cookies.get('lng') && cookies.get('lng') !== undefined){
  default_lng = cookies.get('lng');
}

const fallbackLng = [default_lng];
const availableLanguages = ["en", "ar"];

const resources = {
  en: common_en,
  ar: common_ar
};

i18n
  .use(Backend)
  //.use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,

    detection: {
      checkWhitelist: true
    },

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
